import styled from "styled-components";

export const BannerLink = styled.a`
  width: 100%;
  flex-shrink: 0;
  display: block;
  padding: 12px 20px;
  background: var(--yellow);
  color: var(--grey);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;

  &:hover {
    background: var(--status-yellow);
  }

  &:focus-visible {
    outline: 3px solid var(--grey);
    outline-offset: -3px;
  }
`;

export const Address = styled.span`
  font-weight: 700;
  text-decoration: underline;
  overflow-wrap: anywhere;
`;
